module.exports = __webpack_public_path__ + "media/alarm.d911a041.wav";